import { Center, Image, Stack, Text } from '@mantine/core';
import NotFoundImage from '../../assets/404_not_found.svg';

export function EndpointNotFound() {
	return (
		<Stack align={'center'} w={'100%'} mt={30}>
			<Text fw={500} size={'l'}>
				Oops!
			</Text>
			<Text size={'l'}>
				The page you are trying to access could not be loaded. Please contact
				MedEpos support.
			</Text>

			<Center w={'100%'}>
				<Image src={NotFoundImage} w={'30vw'} m={30} />
			</Center>
		</Stack>
	);
}
